import * as React from "react";
import {useEffect, useState} from "react";
import {sanitize} from "§/src/utils/functions";
import './_header-sub-content.scss';
import { useTranslation } from 'react-i18next';
import ButtonArrow from "§/src/components/atoms/buttons/button-arrow"

const HeaderSubContent = ({children, ...props}) => {
  const { t } = useTranslation();
  const {title, description, disableDivider, ...atomProps} = props;

  // Inizializza isShare a false e isBrowser a false
  const [isShare, setIsShare] = useState(false);
  const [isBrowser, setIsBrowser] = useState(false);

  const atomClassName = 'header-sub-content';
  const atomClass = atomProps.className !== undefined ? atomClassName + ' ' + props.className : atomClassName;

  // Imposta isBrowser a true solo dopo il montaggio del componente (lato client)
  useEffect(() => {
    setIsBrowser(true);
  }, []);

  const onShare = () => {
    // Esegui queste operazioni solo lato client
    if (typeof window !== 'undefined') {
      var dummy = document.createElement('input');
      var text = window.location.href;
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      setIsShare(true);
    }
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (isShare === true) {
        setIsShare(false);
      }
    }, 2000);

    return () => clearTimeout(timeout);
  }, [isShare]);

  // Renderizza sempre il pulsante "Condividi" durante il rendering lato server
  const shareButton = isBrowser && isShare ? (
    <ButtonArrow dir="top-end"
                 text={t('Copiato')}
                 className={'d-flex title-cta btn-link btn text-gray mt-3 mt-md-auto'}/>
  ) : (
    <ButtonArrow dir="top-end"
                 text={t('Condividi')}
                 className={'d-flex title-cta btn-link btn text-black mt-3 mt-md-0 me-auto me-md-0'}
                 onClick={() => onShare()}/>
  );

  return (
    <div className={atomClass}>
      <div className={"d-flex flex-column gap-2"}>
        <div className={"pt-5"}>
          {children}
        </div>
        <div className={"d-flex flex-column flex-md-row justify-content-lg-between gap-md-2 align-items-md-end"}>
          <div className="d-flex flex-column gap-1">
            <h1 className="h2 mb-0">{title}</h1>
            <p className="fs-16 description mb-0" dangerouslySetInnerHTML={{__html: sanitize(description)}}/>
          </div>
          {shareButton}
        </div>
      </div>
      {!disableDivider && (
        <hr className="h-100"/>
      )}
    </div>
  )
}

export default HeaderSubContent
